import {
    GET_POINT_LISTING_FAIL,
    GET_POINT_LISTING_SUCCESS,
    GET_SETTING_LISTING_FAIL,
    GET_SETTING_LISTING_SUCCESS,
    RESET_SETTING_STATE,
    UPDATE_POINT_FAIL,
    UPDATE_POINT_SUCCESS,
    UPDATE_SETTING_FAIL,
    UPDATE_SETTING_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    settingListing: [],
    updateSetting: [],
    pointListing: [],
    updatePoint: [],
    error: [],
}

const Setting = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SETTING_LISTING_SUCCESS:
            return {
                ...state,
                settingListing: action.payload
            }
        case GET_SETTING_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_SETTING_SUCCESS:
            return {
                ...state,
                updateSetting: action.payload
            }
        case UPDATE_SETTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_POINT_LISTING_SUCCESS:
            return {
                ...state,
                pointListing: action.payload
            }
        case GET_POINT_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_POINT_SUCCESS:
            return {
                ...state,
                updatePoint: action.payload
            }
        case UPDATE_POINT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_SETTING_STATE:
            return {
                ...state,
                settingListing: [],
                updateSetting: [],
                pointListing: [],
                updatePoint: [],
                error: [],
            }
        default:
            return state
    }
}

export default Setting
